<template>
  <button :disabled="disabled" class="apio-button" @click="$emit('click')" :class="[buttonTextSize, buttonDisabled, buttonTypeClass, buttonSizeClass]"><slot/></button>
</template>

<script>
export default {
  name: 'apio-button',
  props: {
    'buttonType': {
      default: 'primary'
    },
    'buttonSize': {
      type: String,
      default: 'standard'
    },
    'buttonTextSize': {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonTypeClass() {
      if(this.buttonType === 'secondary' && this.isDarkMode) {
        return 'apio-button--secondary-dark'
      }

      return this.buttonType ? `apio-button--${this.buttonType}` : ''
    },
    buttonSizeClass() {
      return this.buttonSize ? `apio-button--${this.buttonType}-${this.buttonSize}` : ''
    },
    buttonDisabled() {
      return this.disabled ? `apio-button--disabled` : 'apio-button'
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
  }
}
</script>